import request from '@/api/request';
import { MessageType } from '@/interfaces/YC';

interface ReportProps {
  memberId: string
  messageUid: string
  type: MessageType
  description?: string
  text?: string
}
export const report = (
  {
    memberId,
    messageUid,
    type,
    description = '',
    text = ''
  }: ReportProps): Promise<void> => {
  return request(
    'post',
    '/api/report',
    {
      memberId,
      messageUid,
      type,
      description,
      text
    }
  )
    .then(() => Promise.resolve())
}
